import SeparateLine from '@/shared/Forms/SeparateLine'
import InfinityLoader from '@/shared/Loaders/InfinityLoader'
import { Fragment } from 'react'
import NotificationCenterCard from '../NotificationCenterCard'
import NotificationCenterCardSkeleton from '../NotificationCenterCardSkeleton'
import { INotification } from '@/services/Notification/notifications.types'

interface IProps {
  loadMore: () => void
  notifications: INotification[]
  onObserveCard: (el: HTMLElement | null, index: number, notification: INotification) => any
  isMore: boolean
}

const NotificationsList = (props: IProps) => {
  return (
    <InfinityLoader loadMore={props.loadMore} isMore={props.isMore} loader={<NotificationCenterCardSkeleton />}>
      {props.notifications.map((item, index) => (
        <Fragment key={item.id}>
          <NotificationCenterCard
            ref={(el) => props.onObserveCard(el, index, item)}
            notification={item}
            active={!item.seen}
          />
          {index !== props.notifications.length - 1 && <SeparateLine />}
        </Fragment>
      ))}
    </InfinityLoader>
  )
}

export default NotificationsList
